import { APIClient } from "api/api_helper";
import { GetUserData, CurrentUser, formatDateSplit } from "common/service/CommonService";
import { BLOCK_VOLUNTEER_API, VOLUNTEER_API } from "api/url_helper";

const api = new APIClient();

export const blockVolunteerApiService = {
  // INSERT METHOD
  insertData: (payload: any) => {
    const user = GetUserData() as CurrentUser;
    const formData = new FormData();

    const payload_data: Record<string, any> = {
      volunteerid: Number(payload.volunteerid),
      subjectno: payload.subjectno || null,
      studyid: Number(payload.studyid) || null,
      blocktype: payload.blocktype,
      startdate: formatDateSplit(payload.startdate),
      enddate: payload.blocktype === "Permanent" ? null : formatDateSplit(payload.enddate),
      blockduration: payload.blocktype === "Permanent" ? "Permanent" : payload.blockduration,
      blockreason: Number(payload.blockreason),
      blocksource: payload.blocksource || null,
      remarks: payload.remarks || null,
      rescreeningeligibility: payload.blocktype === "Permanent" ? null : payload.rescreeningeligibility,
      createdby: user?.userid,
    };

    // 1. Append form fields
    Object.entries(payload_data).forEach(([key, value]) => {
      if (value !== null) {
        formData.append(key, value as any);
      }
    });

    // 2. Append files
    if (Array.isArray(payload.attachments)) {
      payload.attachments.forEach((file: File) => {
        formData.append("files", file);
      });
    }

    return api.create(BLOCK_VOLUNTEER_API.BLOCK_VOLUNTEER_API + "Insert", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  // SELECT ALL METHOD
  getSelectAllData: (params: {
    searchText: string;
    currentPage: number;
    pageSize: number;
    studyid: number | null;
    blocksource?: string | null;
  }) => {
    const { searchText, currentPage, pageSize, studyid, blocksource } = params;
    const payload = {
      searchtext: searchText,
      currentpage: currentPage,
      pagesize: pageSize,
      studyid: studyid,
      blocksource: blocksource,
    };
    return api.create(BLOCK_VOLUNTEER_API.BLOCK_VOLUNTEER_API + "SelectAll", payload);
  },

  // BLOCK STATUS SELECT METHOD
  getBlockStatus: (volunteerid: number) => {
    return api.create(VOLUNTEER_API.VOLUNTEER_API + "BlockStatusSelect", {
      volunteerid,
    });
  },

  // SELECT METHOD
  getSelectData: (blockid: number) => {
    const payload = {
      blockid: blockid,
    };
    return api.create(BLOCK_VOLUNTEER_API.BLOCK_VOLUNTEER_API + "Select", payload);
  },

  // UPDATE METHOD
  updateData: (payload: any) => {
    const user = GetUserData() as CurrentUser;
    const formData = new FormData();

    const payload_data: Record<string, any> = {
      blockid: Number(payload.blockid),
      volunteerid: Number(payload.volunteerid),
      subjectno: payload.subjectno || null,
      studyid: Number(payload.studyid) || null,
      blocktype: payload.blocktype,
      startdate: formatDateSplit(payload.startdate),
      enddate: payload.blocktype === "Permanent" ? null : formatDateSplit(payload.enddate),
      blockduration: payload.blocktype === "Permanent" ? "Permanent" : payload.blockduration,
      blockreason: Number(payload.blockreason),
      remarks: payload.remarks || null,
      rescreeningeligibility: payload.blocktype === "Permanent" ? null : payload.rescreeningeligibility,
      updatereason: payload.updatereason,
      updatedby: user?.userid,
    };

    // 1. Append form fields
    Object.entries(payload_data).forEach(([key, value]) => {
      if (value !== null) {
        formData.append(key, value as any);
      }
    });

    // 2. Append files
    if (Array.isArray(payload.attachments)) {
      payload.attachments.forEach((file: File) => {
        formData.append("files", file);
      });
    }

    // Handle deleted attachments array if any
    if (payload.deletedAttachmentIds && Array.isArray(payload.deletedAttachmentIds)) {
      formData.append("deletedAttachmentIds", JSON.stringify(payload.deletedAttachmentIds));
    }

    return api.create(BLOCK_VOLUNTEER_API.BLOCK_VOLUNTEER_API + "Update", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  // VERIFY METHOD
  verifyData: (payload: any) => {
    return api.create(BLOCK_VOLUNTEER_API.BLOCK_VOLUNTEER_API + "Verify", payload);
  },

  // DELETE METHOD
  deleteData: (payload: any) => {
    const user = GetUserData() as CurrentUser;
    const payload_data = {
      blockid: Number(payload.blockid),
      updatedby: user?.userid,
      updatereason: payload.updatereason,
    };
    return api.create(BLOCK_VOLUNTEER_API.BLOCK_VOLUNTEER_API + "Delete", payload_data);
  },
};
